export const TAG_CLIMATE_ACTIONS = 'CLIMATE_ACTIONS'
export default [TAG_CLIMATE_ACTIONS]

// Slice
export const SLICE_NAME_CLIMATE_ACTIONS = 'climateActions'
